import { BodyData } from './http-client.interfaces';

export function constructBodyData(data: BodyData) {
  if (typeof data === 'string') {
    return data;
  }

  if (data instanceof FormData) {
    return data;
  }

  if (data instanceof URLSearchParams) {
    return data;
  }

  return JSON.stringify(data);
}
